<template>
<div class="chapter">
<div class="inner_page">
<div class="cbg">
<p class="title1"><a id="page_4"><span class="blue">CONTENTS</span></a></p><a id="page_4">
</a></div><a id="page_4">
</a><div class="cbg1"><a id="page_4">
</a><p class="cha"><a id="page_4"></a><a id="page_5"></a><a href="#/xhtml/06_Introduction"><span class="blue">Introduction</span></a></p>
</div>
<p class="thl1a"><span class="blue"><i>knit</i></span></p>
<p class="linebc">
</p><p class="ch1a"><a href="#/xhtml/08_Chapter02">Key Lime Blanket</a></p>
<p class="cha"><a href="#/xhtml/09_Chapter03">Orangelo Bib</a></p>
<p class="cha"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Paddington Coat</span></p>
<p class="cha"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">“Smocked” Cardigan</span></p>
<p class="cha"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Battenberg Blanket</span></p>
<p class="cha"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Kumquat Blanket</span></p>
<p class="cha"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Campus Onesie</span></p>
<p class="cha"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">Pomelo Slice</span></p>
<p class="cha"><span href="#/xhtml/21_Chapter15" title="Link target outside of Sample">Compass Cap</span></p>
<p class="cha"><span href="#/xhtml/23_Chapter17" title="Link target outside of Sample">Bobbled Blanket</span></p>
<p class="cha"><span href="#/xhtml/25_Chapter19" title="Link target outside of Sample">Jet Age Cardigan</span></p>
<p class="cha"><span href="#/xhtml/26_Chapter20" title="Link target outside of Sample">Moderne Blanket</span></p>
<p class="cha"><span href="#/xhtml/27_Chapter21" title="Link target outside of Sample">Solaria Blanket</span></p>
<p class="cha"><span href="#/xhtml/29_Chapter23" title="Link target outside of Sample">Rag Rug Blanket</span></p>
<p class="cha"><span href="#/xhtml/32_Chapter26" title="Link target outside of Sample">Rivulet Blanket</span></p>
<p class="cha"><span href="#/xhtml/33_Chapter27" title="Link target outside of Sample">Yuzu Blanket</span></p>
<p class="cha"><span href="#/xhtml/34_Chapter28" title="Link target outside of Sample">Clementine Jumper</span></p>
<p class="cha"><span href="#/xhtml/35_Chapter29" title="Link target outside of Sample">Ronald “Snowsuit”</span></p>
<p class="cha"><span href="#/xhtml/36_Chapter30" title="Link target outside of Sample">Diamond Bunting</span></p>
<p class="cha"><span href="#/xhtml/37_Chapter31" title="Link target outside of Sample">Terra Blanket</span></p>
<p class="cha"><span href="#/xhtml/38_Chapter32" title="Link target outside of Sample">Calico Blanket</span></p>
<p class="cha"><span href="#/xhtml/40_Chapter34" title="Link target outside of Sample">Bertie Bird</span></p>
<p class="cha"><span href="#/xhtml/41_Chapter35" title="Link target outside of Sample">Havilland Blanket</span></p>
<p class="cha"><span href="#/xhtml/46_Chapter40" title="Link target outside of Sample">Tuxedo Romper</span></p>
<p class="cha"><span href="#/xhtml/48_Chapter42" title="Link target outside of Sample">Hike Hat</span></p>
<p class="cha"><span href="#/xhtml/53_Chapter47" title="Link target outside of Sample">Scribble Blanket</span></p>
<p class="thl1a"><span class="blue"><i>crochet</i></span></p>
<p class="linebc">
</p><p class="ch1a"><a href="#/xhtml/07_Chapter01">Cleire Cardigan</a></p>
<p class="cha"><a href="#/xhtml/10_Chapter04">Darla Blanket</a></p>
<p class="cha"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Snowflake Blanket</span></p>
<p class="cha"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Slice Cap</span></p>
<p class="cha"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Pink Lemonade Dress</span></p>
<p class="cha"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">High Fidoodlity Blanket</span></p>
<p class="cha"><span href="#/xhtml/22_Chapter16" title="Link target outside of Sample">Citrus Grove Blanket</span></p>
<p class="cha"><span href="#/xhtml/24_Chapter18" title="Link target outside of Sample">Abigail Bolero</span></p>
<p class="cha"><span href="#/xhtml/28_Chapter22" title="Link target outside of Sample">Sideways Cardigan</span></p>
<p class="cha"><span href="#/xhtml/30_Chapter24" title="Link target outside of Sample">Deanna Jumper</span></p>
<p class="cha"><span href="#/xhtml/31_Chapter25" title="Link target outside of Sample">Judi Blanket</span></p>
<p class="cha"><span href="#/xhtml/39_Chapter33" title="Link target outside of Sample">Butterfly Blanket</span></p>
<p class="cha"><span href="#/xhtml/42_Chapter36" title="Link target outside of Sample">Limoges Blanket</span></p>
<p class="cha"><span href="#/xhtml/43_Chapter37" title="Link target outside of Sample">Dickie Sweater</span></p>
<p class="cha"><span href="#/xhtml/44_Chapter38" title="Link target outside of Sample">Sunday Best Dress</span></p>
<p class="cha"><span href="#/xhtml/45_Chapter39" title="Link target outside of Sample">Citron Blanket</span></p>
<p class="cha"><span href="#/xhtml/47_Chapter41" title="Link target outside of Sample">Post &amp; Beam Blanket</span></p>
<p class="cha"><span href="#/xhtml/49_Chapter43" title="Link target outside of Sample">Camellia Blanket</span></p>
<p class="cha"><span href="#/xhtml/50_Chapter44" title="Link target outside of Sample">“Aran” Blanket</span></p>
<p class="cha"><span href="#/xhtml/51_Chapter45" title="Link target outside of Sample">Plié Cardigan</span></p>
<p class="cha"><span href="#/xhtml/52_Chapter46" title="Link target outside of Sample">Limonia Caterpillar</span></p>
<div class="cbg1">
<p class="cha"><span href="#/xhtml/54_Abbreviations" title="Link target outside of Sample"><span class="blue">Abbreviations</span></span></p>
<p class="cha"><span href="#/xhtml/55_Special_Techniques" title="Link target outside of Sample"><span class="blue">Special Techniques</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Content.vue?75c7a821